module.exports = __webpack_public_path__ + "img/minus-ruled-out.58d091b7.svg";